export default {
  latitude: "latitud",
  latitude: "longitud",
  startsWith: "Empieza con",
  contains: "Contiene",
  notContains: "No incluye",
  endsWith: "Termina con",
  equals: "igual",
  notEquals: "no es igual",
  noFilter: "Sin filtro",
  lt: "Menos que",
  lte: "Menos que o igual a",
  gt: "Mayor que",
  gte: "Mayor qué o igual a",
  dateIs: "Fecha es",
  dateIsNot: "Fecha no es",
  dateBefore: "La fecha es antes",
  dateAfter: "La fecha es despues",
  clear: "Limpiar",
  apply: "Aplicar",
  matchAll: "Coincidir con todo",
  matchAny: "Coincide con cualquiera",
  addRule: "Añadir Regla",
  removeRule: "Quitar Regla",
  accept: "Sí",
  reject: "No",
  choose: "Escoger",
  upload: "Subir",
  cancel: "Cancelar",
  dayNames: [
    "Domingo",
    "Lunes",
    "Martes",
    "Miércoles",
    "Jueves",
    "Viernes",
    "Sábado",
  ],
  dayNamesShort: ["Dom", "Lun", "Mar", "Mie", "Jue", "Vie", "Sab"],
  dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
  monthNames: [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
  ],
  monthNamesShort: [
    "Ene",
    "Feb",
    "Mar",
    "Abr",
    "May",
    "Jun",
    "Jul",
    "Ago",
    "Sep",
    "Oct",
    "Nov",
    "Dic",
  ],
  today: "Hoy",
  weekHeader: "Semana",
  firstDayOfWeek: 1,
  dateFormat: "dd-mm-yy",
  weak: "Débil",
  medium: "Mediano",
  strong: "Fuerte",
  passwordPrompt: "Introduce una contraseña",
  emptyFilterMessage: "No se han encontrado resultados",
  emptyMessage: "Sin opciones disponibles",
  uploadedFiles: "Uploaded files",
  uploadFailed: "Upload Failed",
  maxFileLimit: "Max file limit of ${limit} execeeded!",
  aria: {
    trueLabel: "Verdadero",
    falseLabel: "Falso",
    nullLabel: "No seleccionado",
    pageLabel: "PûÀgina",
    firstPageLabel: "Primera PûÀgina",
    lastPageLabel: "û?ltima PûÀgina",
    nextPageLabel: "PûÀgina Siguiente",
    previousPageLabel: "PûÀgina Anterior",
    selectLabel: "Seleccione",
    unselectLabel: "Deseleccionar",
    expandLabel: "Expandir",
    collapseLabel: "Contraer",
  },
  validations: {
    required: "El valor es requerido.",
    undefined: "El valor es requerido.",
    email: "El valor no es una dirección de correo electrónico válida",
    minLength: "Este campo debe tener al menos ${min} caracteres",
    maxLength: "La longitud máxima permitida es ${max}",
    minValue: "El valor mínimo permitido es ${min}",
    maxValue: "El valor máximo permitido es ${max}",
    numeric: "El valor debe ser numérico",
    ipAddress: "El valor no es una dirección IP válida",
    sameAs: "El valor debe ser igual al valor de ${otherName}",
  },
  company: "Empresa",
  company_name: "Nombre de la empresa",
  visitant: "Visitante",
  visitant_name: "Nombre del visitante",
  visitant_email: "Correo electrónico del visitante",
  visitant_phone: "Teléfono del visitante",
  phone: "Teléfono",
  subject: "Motivo",
  visit_to: "Visita a",
  select_to: "Seleccionar a quién visitará",
  date_to_visit: "Fecha de visita",
  time_to_visit: "Hora de visita (24 horas)",
  identification: "Identificación",
  save: "Guardar",
  info_not_permitted:
    "El acceso es únicamente para visita, no se permite trabajar dentro de la planta con este permiso de acceso.",
  show_security_rules: "Mostrar reglas de seguridad",
  employees: "Empleados",
  visitors: "Visitantes",
  welcomeTitle: "¡BIENVENIDOS!",
  welcomeMessage: "Mensaje de bienvenida",
  securityRules: "Reglas de seguridad",
  securityRulesTitle: "REGLAS GENERALES DE SEGURIDAD, HIGIENE Y MEDIO AMBIENTE",
  securityRule1:
    "Está Prohibido fumar dentro de la planta. Solo es permitido fumar en el exterior de planta en el área designada",
  securityRule2:
    "Portar una identificación visible todo el tiempo dentro de las instalaciones.",
  securityRule3:
    "Prohibido ingresar bajo la influencia de alcohol, estupefacientes o cualquier sustancia que altere las facultades mentales o sensoriales.",
  securityRule4:
    "No tomar fotografías o videos dentro de las instalaciones sin autorización de HSE o RH.",
  securityRule5:
    "Prohibido sustraer herramientas, materiales o equipo sin autorización.",
  securityRule6: "Respetar y obedecer todos los señalamientos de seguridad.",
  securityRule7:
    "El equipo de protección personal (EPP) mínimo es: zapato de seguridad, lentes de seguridad, tapones auditivos, chaleco con reflejante (contratistas / proveedores / visitas). Puede requerirse EPP adicional dependiendo del tipo de trabajo.",
  securityRule8: "No se permiten visitantes que tengan un problema de salud.",
  securityRule9: "No se permiten visitantes que tengan alguna discapacidad.",
  securityRule10:
    "No se permiten visitantes que tengan un problema de conducta o que no cumplan los siguientes requisitos:",
  goodPracticesTitle: "BUENAS PRÁCTICAS DE MANUFACTURA Y CÓDIGO DE VESTIMENTA",
  goodPractices1:
    "Prohibido el uso de ropa inapropiada como tops sin mangas, escotes, shorts, pantalones rotos o rasgados. El pantalón debe cubrir completamente la pierna.",
  goodPractices2:
    "Prohibido el uso de zapatos abiertos o con tacones en áreas operativas.",
  goodPractices3: "Consumir alimentos y bebidas solo en las áreas designadas.",
  goodPractices4: "Mantener el área de trabajo ordenada y limpia.",
  goodPractices5:
    "Usar el cabello corto o recogido, y no portar cadenas, anillos, pulseras u otros objetos que puedan atraparse en las áreas operativas.",
  prohibitedItemsTitle: "ARTÍCULOS PROHIBIDOS",
  prohibitedItems1: "Bebidas alcohólicas.",
  prohibitedItems2: "Narcóticos o sustancias controladas.",
  prohibitedItems3: "Explosivos.",
  prohibitedItems4: "Cigarrillos o productos de tabaco.",
  prohibitedItems5: "Armas de fuego o municiones.",
  prohibitedItems6: "Cámaras fotográficas o dedeo sin autorización.",
  prohibitedItems7:
    "Materiales peligrosos sin Hoja de Seguridad y autorización de HSE.",
  prohibitedItems8: "Cuchillas removibles.",
  prohibitedItems9:
    "Motores de combustión interna sin control de emisiones aprobado.",
  close: "Cerrar",
  vendors: "Proveedores",
  employees: "Empleados",
  visitants: "Visitantes",
  visitant_email: "Correo del visitante",
  visitant_phone: "Teléfono del visitante",
  drag_file: "Arrastre el archivo aquí",
  back: "Atrás",
  usernameOrEmail: "Nombre de usuario o correo electrónico",
  password: "Contraseña",
  rememberMe: "Recuérdame",
  forgotpassword: "¿Olvidaste tu contraseña?",
  login: "Iniciar sesión",
  vendorsAccess: "Acceso de proveedores",
  employeesAccess: "Acceso de Colaboradores(as)",
  visitantsAccess: "Acceso de visitantes",
  home: "Inicio",
  welcomeTo: "!Bienvenido a",
  resumeTwoDays: "Resumen de los dos días anteriores",
  toDate: "Hasta la fecha",
  rounds: "Rondas",
  findingsInTransit: "Hallazgo en tránsito",
  findingsOnPatrol: "Hallazgo en ronda",
  incidents: "Incidentes",
  incident: "Incidente",
  findings: "Hallazgos",
  reports: "Reportes",
  monthlyIncidentsReport: "Reporte de incidentes mensual",
  selectMonth: "Seleccionar mes",
  startDate: "Fecha de inicio",
  endDate: "Fecha de fin",
  month: "Mes",
  year: "Año",
  download: "Descargar",
  selectRound: "Seleccionar ronda",
  checkListReport: "Reporte de lista de verificación",
  all: "Todos",
  positive: "Positivo",
  neutral: "Neutral",
  negative: "Negativo",
  roundLogReport: "Bitácora de ronda",
  onlyCompleted: "Solo completados",
  onlyUncompleted: "Solo incompletos",
  onlyWithoutExecuted: "Solo no finalizados",
  opened: "Abierto",
  closed: "Cerrado",
  roundRoute: "Ruta de Ronda",
  tags: "Etiquetas",
  tasks: "Tareas",
  users: "Usuarios",
  administration: "Administración",
  permissions: "Permisos",
  roles: "Roles",
  search: "Buscar",
  export: "Exportar",
  finishedRounds: "Rondas finalizadas",
  OnGoingRounds: "Rondas en curso",
  route: "Ruta",
  realizedBy: "Realizado por",
  occurred: "Ocurrió",
  finished: "Finalizó",
  duration: "Duración",
  accomplishment: "Completado",
  view: "Ver",
  records: "Registros",
  noRecordsFound: "No se encontraron registros",
  of: "de",
  patrols: "Rondínes",
  rejectAccessRequestTitle: "Rechazar solicitud de acceso",
  accessrequests: "Solicitudes de acceso",
  newAccessRequest: "Nueva solicitud de acceso",
  accessLog: "Bitácora de acceso",
  accessvip: "Accesos VIP",
  accesslogvip: "Bitácora de acceso VIP",
  Accesses: "Accesos",
  accountDetails: "Detalles de la cuenta",
  id: "ID",
  name: "Nombre",
  lastname: "Apellido",
  username: "Nombre de usuario",
  email: "Correo electrónico",
  mobile: "Teléfono",
  accountEdit: "Editar cuenta",
  changePassword: "Cambiar contraseña",
  loading: "Cargando...",
  report: "Reporte",
  enterName: "Ingrese el nombre",
  oldpassword: "Contraseña actual",
  newpassword: "Nueva contraseña",
  confirmpassword: "Confirmar contraseña",
  profileImage: "Imagen de perfil",
  enterLastname: "Ingrese el apellido",
  enterUsername: "Ingrese el nombre de usuario",
  enterEmail: "Ingrese el correo electrónico",
  enterMobile: "Ingrese el teléfono",
  requestCannotBeCompleted: "La solicitud no puede ser completada",
  all_rights_reserved: "Todos los derechos reservados",
  myAccount: "Mi cuenta",
  logout: "Cerrar sesión",
  welcome: "¡Bienvenido!",
  accesslog: "Bitácora de acceso",
  actions: "Acciones",
  downloadPDF: "Descargar PDF",
  addNew: "Agregar nuevo",
  enterLabel: "Ingrese la etiqueta",
  send: "Enviar",
  edit: "Editar",
  delete: "Eliminar",
  update: "Actualizar",
  requester: "Solicitante",
  select_a_value: "Seleccione un valor",
  vendor: "Empresa",
  subject: "Motivo",
  enterSubject: "Ingrese el asunto",
  visitMessageRequest:
    "El acceso es únicamente para visita, no se permite trabajar dentro de la planta con este permiso de acceso.",
  visit_to: "Persona a la que visita",
  scheduledVisitDate: "Fecha de visita",
  identification: "Identificación",
  documentation: "Documentación",
  employee: "Empleado",
  fullNameVisitor: "Nombre completo del visitante",
  visitor: "Visitante",
  enterPhone: "Ingrese el teléfono",
  status: "Estado",
  priority: "Prioridad",
  addAccessrequest: "Agregar solicitud de acceso",
  expirationDate: "Fecha de expiración",
  kanban: "Kanban",
  newRequest: "Nueva solicitud",
  requests: "Solicitudes",
  accessRequestStatus: "Estado de la solicitudes de acceso",
  date: "Fecha",
  comment: "Comentario",
  documentationQ: "¿Documentación?",
  noRequireRevision: "No requiere\nrevisión",
  documentationCorrect: "Documentación\ncorrecta",
  requireRevision: "Revisión\npara trabajos",
  acceptedQ: "¿Aceptado?",
  yes: "Sí",
  no: "No",
  Documentación: "Documentación",
  Validación: "Validación",
  Rechazado: "Rechazado",
  Aceptado: "Aceptado",
  Completado: "Completado",
  Invitado: "Invitado",
  add: "Agregar",
  host: "Host",
  enterCompany: "Ingrese la empresa",
  select_date: "Seleccione una fecha",
  taxId: "RFC",
  vendorStatus: "Estado del proveedor",
  repse: "REPSE",
  address: "Dirección",
  requesterDetails: "Detalles del solicitante",
  deleteRecord: "Eliminar registro",
  confirmRecordDeletion: "¿Seguro que quieres borrar este registro?",
  recordDeletedSuccessfully: "Registro eliminado con éxito",
  acceptVisit: "Aceptar visita",
  confirmAcceptVisit: "¿Seguro que quieres aceptar la visita?",
  acceptedSuccessfully: "Aceptado con éxito",
  date_hour: "Fecha y hora",
  type: "Tipo",
  securityGuard: "Guardia de seguridad",
  accessNotes: "Puerta de Acceso/Salida",
  notes: "Notas",
  gaveAccess: "Dió acceso",
  images: "Imagenes",
  qrCode: "Código QR",
  viewQr: "Ver QR",
  notAvailable: "No disponible",
  enterTaxId: "Ingrese el RFC",
  checking: "Comprobando...",
  enterAddress: "Ingrese la dirección",
  formsRequired: "Formularios requeridos",
  formValidationError: "El formulario no es válido",
  formValidationMsg: "Por favor, complete los campos requeridos",
  createRecord: "Crear registro",
  createRecordSuccess: "Registro creado con éxito",
  category: "Categoría",
  updateRecord: "Actualizar registro",
  updateSuccess: "Registro actualizado con éxito",
  bitacora: "Bitácora de control",
  select_a_status: "Seleccione un estado",
  nss: "NSS",
  enterNss: "Ingrese el NSS",
  employeeDetails: "Detalles del empleado",
  forms: "Formularios",
  writeHere: "Escribir aquí",
  carrier: "Carrier",
  carrierrequests: "Solicitudes de acceso carrier",
  rampsDashboards: "Dashboards de Andenes",
  carrier_accesslog: "Bitácora de acceso carrier",
  rampsScreen: "Pantalla de Andenes",
  settings: "Configuraciones",
  vendorsCategories: "Categorias de proveedores",
  departments: "Departamentos",
  priorities: "Prioridades",
  statusRequests: "Estado de las solicitudes",
  statusUsers: "Estado de los usuarios",
  statusVendors: "Estado de los proveedores",
  statusRepse: "Estado de REPSE",
  print: "Imprimir",
  pdf: "PDF",
  excel: "Excel",
  csv: "CSV",
  historyChanges: "Historial de cambios",
  noAuditsRecords: "No hay registros de auditoria",
  change: "Cambio",
  unknown: "Desconocido",
  inProgress: "En progreso",
  created: "Creado",
  updated: "Actualizado",
  deleted: "Eliminado",
  event: "Evento",
  findingReport: "Reporte de Hallazgo",
  findingType: "Tipo de Hallazgo",
  inTransit: "En tránsito",
  onPatrol: "En ronda",
  updating: "Actualizando...",
  changeToClosed: "Cambiar a cerrado",
  changeToOpened: "Cambiar a abierto",
  tag: "Etiqueta",
  task: "Tarea",
  description: "Descripción",
  noImagesAttached: "No hay imagenes adjuntas",
  finishedAt: "FINALIZÓ A LAS",
  round: "Ronda",
  duration: "Duración",
  tagsCompleted: "Etiquetas completadas",
  successFinished: "Finalizado correctamente",
  earlyFinished: "Finalizado anticipadamente",
  notFinished: "No finalizado",
  folio: "Folio",
  doneBy: "Realizado por",
  hour: "Hora",
  comments: "Comentarios",
  user: "Usuario",
  addComment: "Agregar comentario",
  area: "Área",
  responsableOfService: "Responsable de servicio",
  itWasReported: "Se reporto",
  severity: "Severidad",
  shortDescription: "Descripción breve",
  incidentReport: "Reporte de incidente",
  reportDate: "Fecha de reporte",
  ocurrenceDate: "Fecha de ocurrencia",
  reportedBy: "Reportado por",
  deleteSelected: "Eliminar seleccionados",
  addTag: "Agregar etiqueta",
  latitude: "Latitud",
  longitude: "Longitud",
  altitude: "Altitud",
  selectLocation: "Seleccionar ubicación",
  location: "Ubicación",
  drag_marker: "Arrastre el marcador para cambiar la ubicación",
  subcategory: "Subcategoría",
  group: "Grupo",
  keyword: "Palabra clave",
  task: "Tarea",
  enterPassword: "Ingrese la contraseña",
  confirmPassword: "Confirmar contraseña",
  department: "Departamento",
  role: "Rol",
  securityRulesHeader: "Reglas de seguridad",
  welcomeVip: "¡BIENVENIDO",
  seeYouSoonVip: "¡NOS VEMOS PRONTO",
  accessQrCodeQuestion: "¿Registrar ingreso con el código leído?",
  accessQrCodeError: "Hubo un error registrando el ingreso.",
  cameraNotFound: "Cámara no encontrada",
  cameraNotAccess: "No se puede acceder a la cámara",
  toggleCamera: "Cambiar camara",
  confirm: "Confirmar",
  appPatrol: "Aplicación de Rondínes",
  appGuard: "Aplicación de Guardía",
  appCarrier: "Aplicación de Kiosko para Carriers",
  modulePatrol: "Rondínes Resumen",
  moduleGuard: "Accesos Resumen",
  moduleCarrier: "Andenes Resumen",
  patrol: "Rondínes",
  guard: "Guardía",
  carrier: "Kiosko",
  accessInsideBuilding: "Accesos dentro de oficina",
  requestsToApprove: "Solicitudes pendientes",
  approvedRequests: "Solicitudes aceptadas",
  vendorsList: "Padrón de Proveedores",
  monthlyRequests: "Solicitudes mensuales",
  exporting: "Exportando...",
  findingOnPatrol: "Hallazgos en ronda",
  findingInTransit: "Hallazgos en tránsito",
  occurrenceDate: "Fecha de ocurrencia",
  quizTitle: "Encuesta",
  answerQuiz: "Responder encuesta",
  notProhibited1: "Alimentos y bebidas",
  notProhibited2: "Celular y dispositivos electrónicos",
  notGoodPractices1: "Uso de ropa inapropiada y/o casual",
  question1: "¿Cuál es la primera regla de seguridad?",
  question2: "¿Qué está prohibido?",
  question3: "¿Cuál de las siguientes respuestas no es una buena prática?",
  errorQuiz: "Responde al menos 2 correctamente para continuar.",
  vehicles: "Vehículos",
  plates: "Placas",
  model: "Modelo",
  circulation_card: "Tarjeta de circulación",
  vehicle_secure: "Seguro de vehículo",
  enterPlates: "Ingrese las placas",
  enterModel: "Ingrese el modelo",
  select_year: "Seleccione el año",
  fk_vendor: "Proveedor",
  vehicle: "Vehículo",
  tools: "Herramientas",
  computers: "Computadoras",
  serial_number: "Número de serie",
  enterSerialNumber: "Ingrese el número de serie",
  computer_equipment: "Equipo de computo",
  employee_name: "Nombre de empleado",
  categoryServiceMessage:
    "Si la categoría del empleado es Servicios Especializados deberá subir los archivos de Seguro e ISO 14001 así como tener vigente Curso seguridad e higiene y Curso patrimonial.",
  categoryContractorMessage:
    "Si la categoría del empleado es Contratista deberá subir los archivos de Segur así como tener vigente Curso seguridad e higiene y Curso patrimonial.",
  categoryVendorMessage:
    "Si la categoría del proveedor es Proveedor no necesita subir ningun archivo.",
  computer_id: "Equipo de computo",
  tools_id: "Herramientas",
  image: "Imagen",
  captcha_expiration_advisement:
    "¡Despues de validar el captcha cuenta con 5 minutos para realizar la solicitud de visita!.",
  captcha_advisement:
    "Verifique que no es un robot. Los robots no pueden acceder a la planta.",
  needs_assistance_short: "Requiere asistencia",
  needs_assistance: "¿Cuentas con alguna discapacidad que requiera asistencia?",
  assistance_description: "¿Qué tipo de asistencia necesita?",
  acknowledge_policy_agreement_first_part:
    "He leído y acepto apegarme a los lineamientos que se presentan en la ",
  acknowledge_policy_agreement_anchor:
    "Política de Igualdad Laboral y No Discriminación, el Código de Ética y Protocolo de atención a quejas de conductas de discriminación, violencia, acoso y hostigamiento",
  acknowledge_policy_agreement_last_part:
    ", así como asumir las consecuencias que se me puedan aplicar en caso de incumplimiento",
  colaborators: "Colaboradores(as)",
  equality_title: "IGUALDAD LABORAL Y NO DISCRIMINACIÓN",
  equality_intro:
    "En GlobalVoIP, reforzamos nuestro compromiso de cero tolerancia ante actos de violencia, discriminación, acoso y hostigamiento.",
  equality_invitation:
    "Para poder ingresar a nuestras instalaciones, te invitamos a leer y conocer:",
  equality_policy: "Nuestra Política de Igualdad Laboral y No Discriminación",
  ethics_code: "El Código de Ética",
  complaint_protocol:
    "Nuestro Protocolo de atención a quejas de conductas de discriminación, violencia, acoso y hostigamiento",
  view_document: "Ver documento",

  acknowledge_policy_agreement: "Debe de aceptar los lineamientos",
  select_to_hour: "Seleccione una hora",
};
